export default "__VITE_ASSET__3d82f55e__"